import {
  FETCH_DASHBOARD_REQUEST,
  FETCH_DASHBOARD_SUCCESS,
  FETCH_DASHBOARD_FAILURE,
  CLEAR_DASHBOARD_ERRORS,    // Nouvelles imports
  CLEAR_DASHBOARD_SUCCESS,
} from './actionTypes';

const initialState = {
  agencies: [],
  sectors: [],
  configurations: [],
  activities: [],
  quotes: [],
  loadingDashboard: false,
  errorDashboard: null,
  dashboardLoaded: false, // Ajouté pour pouvoir gérer le succès
};

const Dashboard = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_REQUEST:
      return {
        ...state,
        loadingDashboard: true,
        errorDashboard: null,
        dashboardLoaded: false,
      };
    case FETCH_DASHBOARD_SUCCESS:
      return {
        ...state,
        loadingDashboard: false,
        agencies: action.payload.ProjAgencies,
        sectors: action.payload.ProjSectors,
        configurations: action.payload.ProjConfigurations,
        activities: action.payload.Activities,
        quotes: action.payload.ProjQuotes,
        errorDashboard: action.payload.error,
        dashboardLoaded: true, // Indicateur de succès
      };
    case FETCH_DASHBOARD_FAILURE:
      return {
        ...state,
        loadingDashboard: false,
        errorDashboard: action.payload,
        dashboardLoaded: false,
      };
    case CLEAR_DASHBOARD_ERRORS:
      return {
        ...state,
        errorDashboard: null,
      };
    case CLEAR_DASHBOARD_SUCCESS:
      return {
        ...state,
        dashboardLoaded: false,
      };
      
    default:
      return state;
  }
};

export default Dashboard;